const SCHEDULE_LIST_MUTATION = "scheduleListMutation";
export default SCHEDULE_LIST_MUTATION;
